import { createSelector } from 'reselect'
import { selectAccountPreferenceChatEnabled } from 'selectors/app/selectAccountPreferences'
import {
  selectCurrentUserHasChatAccessToCurrentWidget,
  selectWidgetsWithChat,
} from 'ducks/widgets/selectors/widgets'
import { selectWidgetsIsLoading } from 'ducks/widgets/selectors/status'

export const selectIsForbidden = createSelector(
  selectAccountPreferenceChatEnabled,
  selectWidgetsIsLoading,
  selectCurrentUserHasChatAccessToCurrentWidget,
  selectWidgetsWithChat,
  (isChatEnabled, widgetsLoading, hasChatAccess, widgetsWithChat) => {
    if (!isChatEnabled) return true
    // NOTE (jscheel): We don't know about widget status if we are still loading
    // the widgets, so we give them provisional access. Technically this doesn't
    // matter as long as we check the bootstrapped status of the widgets before
    // relying on this selector, but this check makes this selector a bit safer.
    if (widgetsLoading) return false
    if (!hasChatAccess) return true
    if (widgetsWithChat.filter(w => w.hasAccess).length === 0) return true

    return false
  }
)
